import React from "react";
import { useApp } from "@/context/AppContext";
import { localizeDict } from "@/lib/localText";

const scorePassword = (pw) => {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 6) s += 1;
  if (pw.length >= 10) s += 1;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s += 1;
  if (/\d/.test(pw)) s += 1;
  if (/[^A-Za-z0-9]/.test(pw)) s += 1;
  return Math.min(s, 4);
};

const COLORS = ["#DC2626", "#DC2626", "#F59E0B", "#84CC16", "#16A34A"];

const I18N = {
  fr: { prefix: "Robustesse", labels: ["Très faible", "Faible", "Moyen", "Bon", "Fort"] },
  en: { prefix: "Strength", labels: ["Very weak", "Weak", "Fair", "Good", "Strong"] },
  es: { prefix: "Seguridad", labels: ["Muy débil", "Débil", "Media", "Buena", "Fuerte"] },
  pt: { prefix: "Robustez", labels: ["Muito fraca", "Fraca", "Média", "Boa", "Forte"] },
};

// Live password strength meter (informational, non-blocking).
export const PasswordStrength = ({ value, lang = "fr", className = "" }) => {
  const { config } = useApp();
  if (!value) return null;
  const t = localizeDict(I18N, lang, config?.translations, "pwstrength");
  const score = scorePassword(value);
  const pct = Math.max((score / 4) * 100, 12);
  return (
    <div className={`mt-1.5 ${className}`} data-testid="password-strength">
      <div className="h-1.5 rounded-full overflow-hidden" style={{ background: "var(--yalola-surface-alt)" }}>
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{ width: `${pct}%`, background: COLORS[score] }}
          data-testid="password-strength-bar"
        />
      </div>
      <div className="text-[11px] mt-1 font-medium" style={{ color: COLORS[score] }} data-testid="password-strength-label">
        {t.prefix} : {t.labels[score]}
      </div>
    </div>
  );
};

export default PasswordStrength;
